import axios from 'axios';
import { Message } from 'element-ui';
import Config from './config';

class Request {
  static Send(method, pathname, params, success, fail) {
    const options = {
      params,
      data: null,
      url: pathname,
      baseURL: Config.version,
      timeout: Config.timeOut,
      responseType: 'json',
      withCredentials: true,
      maxContentLength: 2000,
      method: method.toLowerCase(),
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    };
    if (options.method === 'post' || options.method === 'put' || options.method === 'patch') {
      options.data = params;
      options.params = null;
    } else {
      options.params = params;
    }
    axios.request(options).then((response) => {
      if (response.data) {
        if (response.data.statusCode === 200) {
          if (typeof success === 'function') {
            success(response.data);
          }
        } else if (response.data.message) {
          Message.error(response.data.message);
        }
      }
    }).catch((error) => {
      if (typeof fail === 'function') {
        fail(error);
      }
    });
  }

  static POST(pathname, params, success, fail) {
    this.Send('POST', pathname, params, success, fail);
  }

  static GET(pathname, params, success, fail) {
    this.Send('GET', pathname, params, success, fail);
  }

  static PUT(pathname, params, success, fail) {
    this.Send('PUT', pathname, params, success, fail);
  }

  static DEL(pathname, params, success, fail) {
    this.Send('DELETE', pathname, params, success, fail);
  }
}

export default Request;



// WEBPACK FOOTER //
// ./src/api/request.js